// extracted by mini-css-extract-plugin
module.exports = {"fieldWrapper":"QuestionTypeValidationStyles_fieldWrapper__YgRRS","questionsTitle":"QuestionTypeValidationStyles_questionsTitle__26iCT"};